class ProductForm extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector("form");
    this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
    this.cartNotification = document.querySelector("cart-notification");
  }

  onSubmitHandler(evt) {
    evt.preventDefault();
    this.cartNotification.setActiveElement(document.activeElement);

    const submitButton = this.querySelector('[type="submit"]');

    submitButton.setAttribute("disabled", true);
    submitButton.classList.add("loading");

    const body = JSON.stringify({
      ...JSON.parse(serializeForm(this.form)),
      sections: this.cartNotification
        .getSectionsToRender()
        .map((section) => section.id),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_add_url}`, { ...fetchConfig("javascript"), body })
      .then((response) => response.json())
      .then((parsedState) => {
        this.cartNotification.renderContents(parsedState);
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        submitButton.classList.remove("loading");
        submitButton.removeAttribute("disabled");
      });
  }
}

customElements.define("product-form", ProductForm);

const cwsGallery = () => {
  const slides = document.querySelectorAll(".product__media-item");
  const images = document.querySelectorAll(".product__modal-opener");

  if (slides.length > 1) {
    const firstSlide = slides[0];
    const lastSlide = slides[slides.length - 1];

    const prevSlide = document.querySelector(".prev-image");
    const nextSlide = document.querySelector(".next-image");
    firstSlide.classList.add("active");
    const firstImg = firstSlide.querySelector("img");
    const firstImgSrc = firstImg.getAttribute("srcset");

    nextSlide?.addEventListener("click", (e) => {
      e.preventDefault();

      let activeSlide = document.querySelector(".product__media-item.active");

      if (activeSlide.nextElementSibling != null) {
        activeSlide.classList.remove("active");
        activeSlide.nextElementSibling.classList.add("active");

        const img = firstSlide.querySelector("img");

        activeSlide = document.querySelector(".product__media-item.active");

        img.setAttribute(
          "srcset",
          activeSlide.querySelector("img").getAttribute("srcset")
        );
      } else {
        activeSlide.classList.remove("active");
        firstSlide.classList.add("active");
        firstImg.setAttribute("srcset", firstImgSrc);
      }
    });

    prevSlide?.addEventListener("click", (e) => {
      e.preventDefault();

      let activeSlide = document.querySelector(".product__media-item.active");

      if (activeSlide.previousElementSibling != null) {
        activeSlide.classList.remove("active");
        activeSlide.previousElementSibling.classList.add("active");

        const img = firstSlide.querySelector("img");

        activeSlide = document.querySelector(".product__media-item.active");

        img.setAttribute(
          "srcset",
          activeSlide.querySelector("img").getAttribute("srcset")
        );

        if (firstSlide.classList.contains("active")) {
          img.setAttribute("srcset", firstImgSrc);
        }
      } else {
        activeSlide.classList.remove("active");
        lastSlide.classList.add("active");
        firstImg.setAttribute(
          "srcset",
          lastSlide.querySelector("img").getAttribute("srcset")
        );
      }
    });

    images.forEach((image) => {
      image.addEventListener("click", () => {
        const img = image.querySelector("img");

        firstImg.setAttribute("srcset", img.getAttribute("srcset"));
      });
    });
  }
};

cwsGallery();
